// In a SSV approach, we store each share price as the PV instead of shares * share price
const normalizeShareValues = ({ share_values }) =>
  share_values.map(sv => ({
    ...sv,
    value: Number(sv.share_price),
  }));

export default normalizeShareValues;
